import React, { useState } from 'react';
import { List } from 'semantic-ui-react';
import APIButton from './shared/APIButton';

const APIIntroList = ({ cat, apis, handleApiSelect, handleCategorySelect, activeApi }) => {

    console.log("CATEGORY IN INTRO LIST: ", cat);
    console.log("ACTIVE API IN INTRO LIST: ", activeApi);

    const [selected, setSelected] = useState('');

    // const handleClick = (api) => {
    //     console.log("API: ", api)
    //     setSelected(api.title)
    // }

    // const apisToDisplay = apis.filter(api => api.category === cat.id);

    return (
            <List className="categories-list">
                <List.Item onClick={() => {handleCategorySelect(cat)}}><a href="#introduction">Introduction</a></List.Item>
                <List.Item onClick={() => {handleCategorySelect(cat)}}><a href="#authentication">Authentication</a></List.Item>
                <List.Item onClick={() => {handleCategorySelect(cat)}}><a href="#responses">Responses</a></List.Item>
                <List.Item onClick={() => {handleCategorySelect(cat)}}><a href="#datatypes">Data Types</a></List.Item>
                {/* {apisToDisplay.map(api => 
                    <List.Item active={selected===cat.title ? true : false} >
                        <div style={{display: "flex"}} onClick={() => {handleApiSelect(api)}}>
                            <span style={{marginRight: "10px"}}><APIButton /></span>
                            <span 
                                className={activeApi.title===api.title ? "selected" : ""}
                            >{api.title}</span>
                        </div>
                    </List.Item>)} */}
            </List>
    )
}

export default APIIntroList;